import { render, staticRenderFns } from "./IndexBanner.vue?vue&type=template&id=91e42c6c&scoped=true"
import script from "./IndexBanner.vue?vue&type=script&lang=js"
export * from "./IndexBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e42c6c",
  null
  
)

export default component.exports